import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { CategoriaService } from '../../categoria/categoria.service';
import { ProductoService } from '../producto.service';
import { RecetaCreateComponent } from '../receta-create/receta-create.component';
import { RecetaService } from '../receta.service';
@Component({
  selector: 'app-producto-view',
  templateUrl: './producto-view.component.html',
  styleUrls: ['./producto-view.component.scss']
})
export class ProductoViewComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  estado_seleccionado!: number
  moneda_seleccionada!: number
  categoria_seleccionada!: number
  @Input() element: any = {}
  @Input() active: number = 1;
  categorias: Array<any> = []
  estado = [{ id: 1, name: 'Activo' }, { id: -1, name: 'Inactivo' }]
  moneda = [{ id: 1, name: 'CLP' }, { id: 2, name: 'USD' }, { id: 3, name: 'UF' }]

  tableItems: any[] = [];
  tableColumns: any[] = [
    {
      label: 'Nombre',
      attribute: 'nombre'
    },
    {
      label: 'Cantidad Producida',
      value: (element: any, index: number) => {
        return this.formatter.numberFormat(element.cantidad)
      }
    },
    {
      label: 'Insumos',
      value: (element: any, index: number) => {
        if (element.lineas.length == 0) return 'Sin gasto de insumos';
        let result = '<ul class="mb-0">';
        element.lineas.forEach((linea: any) => {
          result += `<li>${linea.producto.nombre}: ${this.formatter.numberFormat(linea.cantidad)}</li>`
        });
        return result + '</ul>';
      }
    }
  ];
  tableActions: any[] = [];

  constructor(
    public formBuilder: FormBuilder,
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: ProductoService,
    public activeModal: NgbActiveModal,
    public _service: CategoriaService,
    public recetaService: RecetaService
  ) { this.select() }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      id: [],
      nombre: ['', [Validators.required]],
      descripcion: [],
      sku: [],
      codigo_barra: [],
      precio_venta: [],
      precio_compra: [],
      precio_mayorista: [],
      moneda: ['', Validators.required],
      stock_minimo: [],
      estado: ['', Validators.required],
      categoria_id: [],
    });

    this.form.patchValue({
      ...this.element,
      precio_venta: '$ ' + this.formatter.numberFormat(this.element.precio_venta),
      precio_compra: '$ ' + this.formatter.numberFormat(this.element.precio_compra),
      precio_mayorista: (this.element.precio_mayorista) ? '$ ' + this.formatter.numberFormat(this.element.precio_mayorista): null,
      stock_minimo: (this.element.stock_minimo) ? this.formatter.numberFormat(this.element.stock_minimo) : null
    });
    this.form.disable();
    this.getRecetas(this.element.id);
  }

  select(): void {
    this.loading.show();
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this._service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.categorias = res;
      }, error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo Cargar Tipos de gastos de la empresa", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    })
  }

  getRecetas(id: number): void {
    this.loading.show()
    this.recetaService.recetasDeProducto(id).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.tableItems = res;
      }, error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  addReceta(): void {
    const modalRef = this.modalService.open(RecetaCreateComponent, { size: 'lg', scrollable: true });
    modalRef.componentInstance.producto_id = this.element.id;
    modalRef.result.then((result: any) => {
      this.getRecetas(this.element.id);
    }, (reason: any) => { });
  }

  editReceta(element: any, index: number): void {

  }

  deleteReceta(element: any, index: number): void {

  }
}
